import pictShortcutHome from '../assets/icones/shortcut/management/home.svg'
import pictShortcutUser from '../assets/icones/shortcut/management/user.svg'
import pictShortcutTag from '../assets/icones/shortcut/management/tag.svg'
import pictShortcutRole from '../assets/icones/shortcut/management/role.svg'
import pictShortcutCompany from '../assets/icones/shortcut/management/company.svg'
import pictShortcutRgpd from '../assets/icones/shortcut/management/rgpd.svg'
import pictShortcutLog from '../assets/icones/shortcut/management/log.svg'
import pictShortcutReferential from '../assets/icones/shortcut/items/referential.svg'
import pictShortcutItemCatalog from '../assets/icones/shortcut/items/item-catalog.svg'
import pictShortcutCatalogManager from '../assets/icones/shortcut/items/catalog-manager.svg'
import pictShortcutPriceKiosk from '../assets/icones/shortcut/prices/kiosk.svg'
import pictShortcutPriceItem from '../assets/icones/shortcut/prices/item.svg'
import pictShortcutPriceUpdate from '../assets/icones/shortcut/prices/price-update.svg'
import pictShortcutPricePromotion from '../assets/icones/shortcut/prices/promotion.svg'
import pictShortcutSummary from '../assets/icones/shortcut/stocks/summary.svg'
import pictShortcutSaleKiosk from '../assets/icones/shortcut/sales/kiosk.svg'
import pictShortcutSaleItem from '../assets/icones/shortcut/sales/item.svg'
import pictShortcutConsignment from '../assets/icones/shortcut/sales/consignment.svg'
import pictShortcutSaleCode from '../assets/icones/shortcut/sales/code.svg'
import pictShortcutPaymentCollection from '../assets/icones/shortcut/sales/payment-collection.svg'
import pictShortcutCodeGeneration from '../assets/icones/shortcut/sales/code-generation.svg'
import pictShortcutKioskCreate from '../assets/icones/shortcut/kiosk/kiosk-create.svg'
import pictShortcutKioskProductionList from '../assets/icones/shortcut/kiosk/kiosk-production-list.svg'
import pictShortcutSaleMarketing from '../assets/icones/shortcut/sales/marketing.svg'
import pictShortcutLanguage from '../assets/icones/shortcut/management/language.svg'
import pictShortcutTransactionAnalysis from '../assets/icones/shortcut/kiosk/transaction-analysis.svg'

import pictDivisionManufacturer from '../assets/icones/companyType/manufacturer.svg'
import pictDivisionOwner from '../assets/icones/companyType/owner.svg'
import pictDivisionStoreManager from '../assets/icones/companyType/store-manager.svg'
import pictDivisionStore from '../assets/icones/companyType/store.svg'
import pictDivisionTechSupport from '../assets/icones/companyType/tech-support.svg'
import pictDivisionHierarchicalGroup from '../assets/icones/companyType/hierarchical-group.svg'
import pictDivisionDistributor from '../assets/icones/companyType/distributor.svg'
import pictDivisionDistributionGroup from '../assets/icones/companyType/distribution-group.svg'
import pictDivisionReseller from '../assets/icones/companyType/reseller.svg'
import pictDivisionHierarchicalSubGroup from '../assets/icones/companyType/hierarchical-subgroup.svg'

import pictUsagesBbq from '../assets/icones/item/usages/bbq.png'
import pictUsagesCamping from '../assets/icones/item/usages/camping.png'
import pictUsagesDesherbeur from '../assets/icones/item/usages/desherbeur.png'
import pictUsagesWeldingTorch from '../assets/icones/item/usages/welding-torch.png'
import pictUsagesShower from '../assets/icones/item/usages/shower.png'
import pictUsagesCookingPot from '../assets/icones/item/usages/cooking-pot.png'
import pictUsagesPatioHeater from '../assets/icones/item/usages/patio-heater.png'
import pictUsagesOcho from '../assets/icones/item/usages/ocho.png'
import pictUsagesHeating from '../assets/icones/item/usages/heating.png'

import pictArticleStatusActivated from '../assets/icones/status/itemReferentiel/activated.svg'
import pictArticleStatusActivationScheduled from '../assets/icones/status/itemReferentiel/activation-scheduled.svg'
import pictArticleStatusDeactivated from '../assets/icones/status/itemReferentiel/deactivated.svg'
import pictArticleStatusDesactivationProgInProgress from '../assets/icones/status/itemReferentiel/deactivation-progressive-inprogress.svg'
import pictArticleStatusDesactivationProgScheduled from '../assets/icones/status/itemReferentiel/deactivation-progressive-scheduled.svg'

import pictArticleLifeStatusActivated from '../assets/icones/status/itemLife/activated.svg'
import pictArticleLifeStatusActivationScheduled from '../assets/icones/status/itemLife/activation-scheduled.svg'
import pictArticleLifeStatusDeactivated from '../assets/icones/status/itemLife/deactivated.svg'
import pictArticleLifeStatusDesactivationProgInProgress from '../assets/icones/status/itemLife/deactivation-progressive-inprogress.svg'
import pictArticleLifeStatusDesactivationProgScheduled from '../assets/icones/status/itemLife/deactivation-progressive-scheduled.svg'

import pictKioskRequestBusinessStockRequest from '../assets/icones/status/kioskRequest/business/stock-request.svg'
// Seems that we won't have this subFlow anymore because no more save mode
//import pictKioskRequestBusinessStartedRequest from '../assets/icones/status/kioskRequest/business/started-request.svg'
import pictKioskRequestBusinessProspectRequest from '../assets/icones/status/kioskRequest/business/prospect-request.svg'
import pictKioskRequestBusinessPendingQuote from '../assets/icones/status/kioskRequest/business/pending-quote.svg'
import pictKioskRequestBusinessKioskInfoVerified from '../assets/icones/status/kioskRequest/business/kioskInfo-verified.svg'
import pictKioskRequestBusinessCanceledRequest from '../assets/icones/status/kioskRequest/business/canceled-request.svg'

// Seems that we won't have this subFlow anymore because no more save mode
//import pictKioskRequestBusinessStartedRequest from '../assets/icones/status/kioskRequest/business/started-request.svg'
import pictKioskRequestCustomerRequestValidated from '../assets/icones/status/kioskRequest/customer/request-validated.svg'
import pictKioskRequestCustomerRequestMade from '../assets/icones/status/kioskRequest/customer/request-made.svg'
import pictKioskRequestCustomerRequestCanceled from '../assets/icones/status/kioskRequest/customer/request-canceled.svg'
import pictKioskRequestCustomerQuoteSent from '../assets/icones/status/kioskRequest/customer/quote-sent.svg'
import pictKioskRequestCustomerKioskWaitingAssignment from '../assets/icones/status/kioskRequest/customer/kiosk-waiting-assignment.svg'
import pictKioskRequestCustomerConfigInProgress from '../assets/icones/status/kioskRequest/customer/config-in-progress.svg'
import pictKioskRequestCustomerConfigDone from '../assets/icones/status/kioskRequest/customer/config-done.svg'
import pictKioskRequestCustomerBuildInProgress from '../assets/icones/status/kioskRequest/customer/build-in-progress.svg'
import pictKioskRequestCustomerBuildDone from '../assets/icones/status/kioskRequest/customer/build-done.svg'

export const shortcutPicsConfig = [
	{ id: 33, picture: pictShortcutHome },
	{ id: 24, picture: pictShortcutUser },
	{ id: 25, picture: pictShortcutTag },
	{ id: 26, picture: pictShortcutRole },
	{ id: 27, picture: pictShortcutCompany },
	{ id: 28, picture: pictShortcutRgpd },
	{ id: 29, picture: pictShortcutLog },
	{ id: 30, picture: pictShortcutLog },
	{ id: 31, picture: pictShortcutLog },
	{ id: 32, picture: pictShortcutLog },
	{ id: 40, picture: pictShortcutLanguage },

	{ id: 12, picture: pictShortcutReferential },
	{ id: 38, picture: pictShortcutItemCatalog },
	{ id: 39, picture: pictShortcutCatalogManager },

	{ id: 13, picture: pictShortcutPriceKiosk },
	{ id: 14, picture: pictShortcutPriceItem },
	{ id: 15, picture: pictShortcutPriceUpdate },
	{ id: 16, picture: pictShortcutPricePromotion },
	{ id: 17, picture: pictShortcutSummary },
	{ id: 18, picture: pictShortcutSaleKiosk },
	{ id: 19, picture: pictShortcutSaleItem },
	{ id: 20, picture: pictShortcutConsignment },
	{ id: 21, picture: pictShortcutSaleCode },
	{ id: 22, picture: pictShortcutPaymentCollection },
	{ id: 34, picture: pictShortcutKioskCreate },
	{ id: 35, picture: pictShortcutKioskCreate },
	{ id: 23, picture: pictShortcutCodeGeneration },
	{ id: 36, picture: pictShortcutSaleMarketing },
	{ id: 37, picture: pictShortcutKioskProductionList },
	{ id: 41, picture: pictShortcutTransactionAnalysis },
]

export const divisionPicsConfig = [
	{ id: 1, picture: pictDivisionManufacturer },
	{ id: 2, picture: pictDivisionOwner },
	{ id: 3, picture: pictDivisionStoreManager },
	{ id: 4, picture: pictDivisionStore },
	{ id: 5, picture: pictDivisionTechSupport },
	{ id: 6, picture: pictDivisionHierarchicalGroup },
	{ id: 7, picture: pictDivisionHierarchicalSubGroup },
	{ id: 8, picture: pictDivisionDistributor },
	{ id: 9, picture: pictDivisionDistributionGroup },
	{ id: 10, picture: pictDivisionReseller },
]

export const usagePicsConfig = [
	{ id: 1, picture: pictUsagesBbq },
	{ id: 2, picture: pictUsagesCamping },
	{ id: 3, picture: pictUsagesDesherbeur },
	{ id: 4, picture: pictUsagesWeldingTorch },
	{ id: 5, picture: pictUsagesShower },
	{ id: 6, picture: pictUsagesCookingPot },
	{ id: 7, picture: pictUsagesPatioHeater },
	{ id: 8, picture: pictUsagesOcho },
	{ id: 9, picture: pictUsagesHeating },
]

export const articleStatusPicsConfig = [
	{ subFlow: '100', picture: pictArticleStatusActivated },
	{ subFlow: '500', picture: pictArticleStatusActivationScheduled },
	{ subFlow: '200', picture: pictArticleStatusDeactivated },
	{ subFlow: '400', picture: pictArticleStatusDesactivationProgInProgress },
	{ subFlow: '300', picture: pictArticleStatusDesactivationProgScheduled },
]

export const articleLifeStatusPicsConfig = [
	{ subFlow: '100', picture: pictArticleLifeStatusActivated },
	{ subFlow: '500', picture: pictArticleLifeStatusActivationScheduled },
	{ subFlow: '200', picture: pictArticleLifeStatusDeactivated },
	{ subFlow: '400', picture: pictArticleLifeStatusDesactivationProgInProgress },
	{ subFlow: '300', picture: pictArticleLifeStatusDesactivationProgScheduled },
]

export const kioskBusinessRequestStatusPicsConfig = [
	{ subFlow: '100', picture: pictKioskRequestBusinessStockRequest },
	//{"subFlow": "", "picture": pictKioskRequestBusinessStartedRequest}, => Seems that we won't have this subFlow anymore because no more save mode
	{ subFlow: '200', picture: pictKioskRequestBusinessProspectRequest },
	{ subFlow: '400', picture: pictKioskRequestBusinessPendingQuote },
	//{"subFlow": "500", "picture": pictKioskRequestBusinessValidate},
	{ subFlow: '300', picture: pictKioskRequestBusinessKioskInfoVerified },
	{ subFlow: 'ANN', picture: pictKioskRequestBusinessCanceledRequest },
]

export const kioskCustomerRequestStatusPicsConfig = [
	//{"subFlow": "", "picture": pictKioskRequestBusinessStartedRequest}, => Seems that we won't have this subFlow anymore because no more save mode
	{ subFlow: '100', picture: pictKioskRequestCustomerRequestMade },
	{ subFlow: '200', picture: pictKioskRequestCustomerRequestMade },
	{ subFlow: '300', picture: pictKioskRequestCustomerRequestMade },
	{ subFlow: '400', picture: pictKioskRequestCustomerQuoteSent },
	{ subFlow: 'ANN', picture: pictKioskRequestCustomerRequestCanceled },
	{ subFlow: '500', picture: pictKioskRequestCustomerRequestValidated },
	{ subFlow: '600', picture: pictKioskRequestCustomerConfigInProgress },
	{ subFlow: '700', picture: pictKioskRequestCustomerConfigInProgress },
	{ subFlow: '800', picture: pictKioskRequestCustomerConfigInProgress },
	{ subFlow: '900', picture: pictKioskRequestCustomerConfigInProgress },
	{ subFlow: '1000', picture: pictKioskRequestCustomerConfigDone },
	{ subFlow: '1100', picture: pictKioskRequestCustomerBuildInProgress },
	{ subFlow: '1200', picture: pictKioskRequestCustomerBuildInProgress },
	{ subFlow: '1300', picture: pictKioskRequestCustomerBuildInProgress },
	{ subFlow: '1400', picture: pictKioskRequestCustomerBuildInProgress },
	{ subFlow: '1500', picture: pictKioskRequestCustomerBuildInProgress },
	{ subFlow: '1600', picture: pictKioskRequestCustomerBuildInProgress },
	{ subFlow: '1700', picture: pictKioskRequestCustomerBuildDone },
	{ subFlow: '1800', picture: pictKioskRequestCustomerKioskWaitingAssignment },
]
